<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<!-- Event Templates -->
<div class="events-list-container elevate">
  <div class="icon-text-container">
    <mat-icon class="alloy-icon" svgIcon="ic_crucible_alloy"></mat-icon>
    <span class="title-text text">My Events</span>
    <div class="searchBox">
      <mat-form-field style="width: 320px">
        <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event.target.value)" placeholder="Search" />
        @if (filterString) {
        <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
          <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
        </button>
        }
      </mat-form-field>
      <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons
        aria-label="Select page of events">
      </mat-paginator>
    </div>
  </div>
  @if (!doneLoading) {
  <mat-card class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </mat-card>
  }
  <!-- Event Templates-->
  <div class="table-container">
    <mat-table #sortTemplate="matSort" [dataSource]="eventTemplateDataSource" matSort>
      @for (col of eventTemplateDisplayedColumns; track col; let i = $index) {
      <ng-container matColumnDef="{{ col }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnHeaders[col] }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <!-- Only Show link if its the first element-->
          @if (i === 0) {
          <div class="link-text">
            <a [routerLink]="['/templates', element.id]">{{ element.name }}</a>
          </div>
          } @else {
          {{ element[col] }}
          }
        </mat-cell>
      </ng-container>
      }

      <mat-header-row *matHeaderRowDef="eventTemplateDisplayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: eventTemplateDisplayedColumns"></mat-row>
    </mat-table>
  </div>

  @if (eventTemplateDataSource.filteredData.length === 0) {
  <div>
    No results found
  </div>
  }
</div>
